import { Business as API } from '@src/api/types';
import { PlaceTag as Data } from '@src/types';

const Factory = (api?: API): Data | undefined =>
  api
    ? {
        id: api.id,
        name: api.localName,
      }
    : undefined;

export default Factory;
